import { render, staticRenderFns } from "./LostOrDamagedPassport.vue?vue&type=template&id=0649a75a&scoped=true&"
import script from "./LostOrDamagedPassport.vue?vue&type=script&lang=js&"
export * from "./LostOrDamagedPassport.vue?vue&type=script&lang=js&"
import style0 from "./LostOrDamagedPassport.vue?vue&type=style&index=0&id=0649a75a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649a75a",
  null
  
)

export default component.exports